// Generated by CoffeeScript 1.12.7
(function () {
  var RecentViewsVisualization;

  module.exports = RecentViewsVisualization = (function () {
    function RecentViewsVisualization(createUi, make, $q, $timeout, eventData, options) {
      var shouldShow;
      if (options == null) {
        options = {};
      }
      shouldShow = true;
      if (eventData.scope.projectId == null || eventData.scope.projectId === "") {
        shouldShow = false;
      }
      this.ui = createUi(require("./RecentViews.html"), {
        shouldShow: shouldShow,
        views: [],
        showProjectName: options.showProjectName,
        loaded: false,
        showDetail: function (view) {
          var projectDetail;
          projectDetail = make(require("../Detail/Detail"), {
            view: view,
            projectId: eventData.scope.projectId || "",
          });
          return projectDetail.show();
        },
      });
      eventData.getRecentViews().then(
        (function (_this) {
          return function (results) {
            _this.ui.views = results;
            return (_this.ui.loaded = true);
          };
        })(this),
      );
    }

    return RecentViewsVisualization;
  })();
}.call(this));
